import React from 'react'
import './Id.scss'

const Id = () => {
  return (
    <div>Id</div>
  )
}

export default Id